module.exports = __webpack_public_path__ + "assets/img/ozmo-linkedin.cb30fd97.png";